











































































import {Component} from 'vue-property-decorator';
import {Getter} from "vuex-class";
import {SystemActionsItem} from "@/store/user_management/system_actions/types";
import SystemActionsFilter from "@/components/UserManagement/SystemActionsFilter.vue";
import {ScrollButton} from "wings-ui-components";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";

@Component({
  components: {SystemActionsFilter, ScrollButton}
})
export default class SystemActions extends BaseItemsPage<SystemActionsItem> {
  @Getter("systemUsersAction") responseItems!: SystemActionsItem[];
  private is_show_filter: boolean = true;
  private localLang: string = 'ru';

  currentSort= 'id';
  currentSortOrder= 'desc';
  tableFields = ['name', 'rus_name', 'eng_name', 'action_source', 'is_allowed'];

  async created() {
    this.localLang = this.$i18n.locale;
  }

  getData(): SystemActionsItem[] {
    return this.responseItems;
  }
}
